export default "__VITE_ASSET__VDUTegZJ__"